import { AppModule } from 'app/module';
import { MasterLayout } from 'layout/master/main';
import { ENDPOINT_USER_LOGIN } from 'app/endpoints';
import Template from './template.hbs';
import './styles.scss';

export class ResultState extends AppModule {
    setTemplate() {
        this.template = Template;
        if (module.hot) {
            module.hot.accept('./template.hbs', () => {
                this.template = Template;
                this.render();
            });
        }
    }

    domBindings() {
        return {
            spotImage: '.m-resultState__spotImage',
            resultHeadline: '.m-resultState__resultHeadline',
            resultSubtitle: '.m-resultState__resultSubtitle',
            loginLink: '.m-resultState__loginLink',
            loginButton: '.m-resultState__loginButton',
        };
    }

    getPropsFromDom() {
        return {
            imagePath: this.dom.spotImage?.src ?? '',
            retinaImagePath: this.dom.spotImage?.getAttribute('data-retinaImagePath') ?? '',
            title: this.dom.resultHeadline?.innerText ?? null,
            subtitle: this.dom.resultSubtitle.innerText ?? '',
            jobAlarmId: this.dom.el.getAttribute('data-jobAlarmId') ?? '',
            redirectLink: this.dom.el.getAttribute('data-redirectLink') ?? '',
        };
    }

    domEvents() {
        if (this.dom.loginLink) {
            this.dom.loginLink.addEventListener('click', (e) => {
                if (e) e.preventDefault();
                const jobAlarmIdRedirect = this.props.jobAlarmId ? `/${this.props.jobAlarmId}` : '';
                // eslint-disable-next-line max-len
                this.layout.openLoginModal(`${ENDPOINT_USER_LOGIN}?redirectUrl=${this.props.redirectLink}${jobAlarmIdRedirect}`, true, true);
            });
        }
        if (this.dom.loginButton) {
            this.dom.loginButton.addEventListener('click', (e) => {
                if (e) e.preventDefault();
                const jobAlarmIdRedirect = this.props.jobAlarmId ? `/${this.props.jobAlarmId}` : '';
                // eslint-disable-next-line max-len
                this.layout.openLoginModal(`${ENDPOINT_USER_LOGIN}?redirectUrl=${this.props.redirectLink}${jobAlarmIdRedirect}`, true, true);
            });
        }
    }

    subs() {
        this.layout = new MasterLayout(document.documentElement);
    }
}
